/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getSite = /* GraphQL */ `
  query GetSite($id: ID!) {
    getSite(id: $id) {
      id
      csid
      name
      description
      latitude
      longitude
      geohash
      address
      customer_name
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSites = /* GraphQL */ `
  query ListSites(
    $id: ID
    $filter: ModelSiteFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSites(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        csid
        name
        description
        latitude
        longitude
        geohash
        address
        customer_name
        cameras {
          items {
            id
            camera_asset_id
            name
            latitude
            longitude
            geohash
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            site_id
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            http_stream
            video_gateway
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        routes {
          items {
            id
            name
            route_type {
              id
              name
              routes {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            route_type_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            site_id
            schedules {
              items {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        checkpoints {
          items {
            id
            name
            description
            checklist
            site_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            camera_id
            camera {
              id
              camera_asset_id
              name
              latitude
              longitude
              geohash
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              checkpoints {
                nextToken
                __typename
              }
              http_stream
              video_gateway
              createdAt
              updatedAt
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCamera = /* GraphQL */ `
  query GetCamera($id: ID!) {
    getCamera(id: $id) {
      id
      camera_asset_id
      name
      latitude
      longitude
      geohash
      http_stream
      video_gateway
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCameras = /* GraphQL */ `
  query ListCameras(
    $id: ID
    $filter: ModelCameraFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listCameras(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        camera_asset_id
        name
        latitude
        longitude
        geohash
        site {
          id
          csid
          name
          description
          latitude
          longitude
          geohash
          address
          customer_name
          cameras {
            items {
              id
              camera_asset_id
              name
              latitude
              longitude
              geohash
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              checkpoints {
                nextToken
                __typename
              }
              http_stream
              video_gateway
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          routes {
            items {
              id
              name
              route_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              route_type_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              schedules {
                nextToken
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          checkpoints {
            items {
              id
              name
              description
              checklist
              site_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              camera_id
              camera {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        site_id
        checkpoints {
          items {
            id
            name
            description
            checklist
            site_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            camera_id
            camera {
              id
              camera_asset_id
              name
              latitude
              longitude
              geohash
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              checkpoints {
                nextToken
                __typename
              }
              http_stream
              video_gateway
              createdAt
              updatedAt
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        http_stream
        video_gateway
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listCamerasByName = /* GraphQL */ `
  query ListCamerasByName(
    $name: String!
    $sortDirection: ModelSortDirection
    $filter: ModelCameraFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCamerasByName(
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        camera_asset_id
        name
        latitude
        longitude
        geohash
        site {
          id
          csid
          name
          description
          latitude
          longitude
          geohash
          address
          customer_name
          cameras {
            items {
              id
              camera_asset_id
              name
              latitude
              longitude
              geohash
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              checkpoints {
                nextToken
                __typename
              }
              http_stream
              video_gateway
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          routes {
            items {
              id
              name
              route_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              route_type_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              schedules {
                nextToken
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          checkpoints {
            items {
              id
              name
              description
              checklist
              site_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              camera_id
              camera {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        site_id
        checkpoints {
          items {
            id
            name
            description
            checklist
            site_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            camera_id
            camera {
              id
              camera_asset_id
              name
              latitude
              longitude
              geohash
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              checkpoints {
                nextToken
                __typename
              }
              http_stream
              video_gateway
              createdAt
              updatedAt
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        http_stream
        video_gateway
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listCamerasBySite = /* GraphQL */ `
  query ListCamerasBySite(
    $site_id: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCameraFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCamerasBySite(
      site_id: $site_id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        camera_asset_id
        name
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getIncidentType = /* GraphQL */ `
  query GetIncidentType($id: ID!) {
    getIncidentType(id: $id) {
      id
      name
      checkpoint_records {
        items {
          id
          order
          record_id
          record {
            id
            schedule_id
            schedule {
              id
              route_id
              route {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              operator_ids
              cron_expression
              deleted
              deletedAt
              records {
                nextToken
                __typename
              }
              patrols {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            report_url
            operator_id
            start_time
            end_time
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          checkpoint_id
          checkpoint {
            id
            name
            description
            checklist
            site_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            camera_id
            camera {
              id
              camera_asset_id
              name
              latitude
              longitude
              geohash
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              checkpoints {
                nextToken
                __typename
              }
              http_stream
              video_gateway
              createdAt
              updatedAt
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          incident_type_id
          incident_type {
            id
            name
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          checklist_results
          completed_at
          image_url
          notes
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listIncidentTypes = /* GraphQL */ `
  query ListIncidentTypes(
    $id: ID
    $filter: ModelIncidentTypeFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listIncidentTypes(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        name
        checkpoint_records {
          items {
            id
            order
            record_id
            record {
              id
              schedule_id
              schedule {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              report_url
              operator_id
              start_time
              end_time
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            checkpoint_id
            checkpoint {
              id
              name
              description
              checklist
              site_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              camera_id
              camera {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            incident_type_id
            incident_type {
              id
              name
              checkpoint_records {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            checklist_results
            completed_at
            image_url
            notes
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getRoute = /* GraphQL */ `
  query GetRoute($id: ID!) {
    getRoute(id: $id) {
      id
      name
      route_type {
        id
        name
        routes {
          items {
            id
            name
            route_type {
              id
              name
              routes {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            route_type_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            site_id
            schedules {
              items {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      route_type_id
      site {
        id
        csid
        name
        description
        latitude
        longitude
        geohash
        address
        customer_name
        cameras {
          items {
            id
            camera_asset_id
            name
            latitude
            longitude
            geohash
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            site_id
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            http_stream
            video_gateway
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        routes {
          items {
            id
            name
            route_type {
              id
              name
              routes {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            route_type_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            site_id
            schedules {
              items {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        checkpoints {
          items {
            id
            name
            description
            checklist
            site_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            camera_id
            camera {
              id
              camera_asset_id
              name
              latitude
              longitude
              geohash
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              checkpoints {
                nextToken
                __typename
              }
              http_stream
              video_gateway
              createdAt
              updatedAt
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      site_id
      schedules {
        items {
          id
          route_id
          route {
            id
            name
            route_type {
              id
              name
              routes {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            route_type_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            site_id
            schedules {
              items {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          operator_ids
          cron_expression
          deleted
          deletedAt
          records {
            items {
              id
              schedule_id
              schedule {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              report_url
              operator_id
              start_time
              end_time
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          patrols {
            items {
              id
              schedule_id
              schedule {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              completed
              operator_ids
              datetime
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          type
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      route_checkpoints {
        items {
          id
          route_id
          checkpoint_id
          order
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      type
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listRoutes = /* GraphQL */ `
  query ListRoutes(
    $id: ID
    $filter: ModelRouteFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listRoutes(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        name
        route_type {
          id
          name
          routes {
            items {
              id
              name
              route_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              route_type_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              schedules {
                id
                nextToken
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        route_type_id
        site {
          id
          csid
          name
          description
          latitude
          longitude
          geohash
          address
          customer_name
          cameras {
            items {
              id
              camera_asset_id
              name
              latitude
              longitude
              geohash
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              checkpoints {
                nextToken
                __typename
              }
              http_stream
              video_gateway
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          routes {
            items {
              id
              name
              route_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              route_type_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              schedules {
                nextToken
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          checkpoints {
            items {
              id
              name
              description
              checklist
              site_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              camera_id
              camera {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        site_id
        schedules {
          items {
            id
            route_id
            route {
              id
              name
              route_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              route_type_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              schedules {
                nextToken
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            operator_ids
            cron_expression
            deleted
            deletedAt
            records {
              items {
                id
                schedule_id
                report_url
                operator_id
                start_time
                end_time
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            patrols {
              items {
                id
                schedule_id
                completed
                operator_ids
                datetime
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        route_checkpoints {
          items {
            id
            route_id
            checkpoint_id
            order
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        type
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const routesByRoute_type_id = /* GraphQL */ `
  query RoutesByRoute_type_id(
    $route_type_id: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelRouteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    routesByRoute_type_id(
      route_type_id: $route_type_id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        route_type {
          id
          name
          routes {
            items {
              id
              name
              route_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              route_type_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              schedules {
                nextToken
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        route_type_id
        site {
          id
          csid
          name
          description
          latitude
          longitude
          geohash
          address
          customer_name
          cameras {
            items {
              id
              camera_asset_id
              name
              latitude
              longitude
              geohash
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              checkpoints {
                nextToken
                __typename
              }
              http_stream
              video_gateway
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          routes {
            items {
              id
              name
              route_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              route_type_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              schedules {
                nextToken
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          checkpoints {
            items {
              id
              name
              description
              checklist
              site_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              camera_id
              camera {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        site_id
        schedules {
          items {
            id
            route_id
            route {
              id
              name
              route_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              route_type_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              schedules {
                nextToken
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            operator_ids
            cron_expression
            deleted
            deletedAt
            records {
              items {
                id
                schedule_id
                report_url
                operator_id
                start_time
                end_time
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            patrols {
              items {
                id
                schedule_id
                completed
                operator_ids
                datetime
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        route_checkpoints {
          items {
            id
            route_id
            checkpoint_id
            order
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        type
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const routesBySite_id = /* GraphQL */ `
  query RoutesBySite_id(
    $site_id: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelRouteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    routesBySite_id(
      site_id: $site_id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        route_type {
          id
          name
          routes {
            items {
              id
              name
              route_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              route_type_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              schedules {
                nextToken
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        route_type_id
        site {
          id
          csid
          name
          description
          latitude
          longitude
          geohash
          address
          customer_name
          cameras {
            items {
              id
              camera_asset_id
              name
              latitude
              longitude
              geohash
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              checkpoints {
                nextToken
                __typename
              }
              http_stream
              video_gateway
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          routes {
            items {
              id
              name
              route_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              route_type_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              schedules {
                nextToken
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          checkpoints {
            items {
              id
              name
              description
              checklist
              site_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              camera_id
              camera {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        site_id
        schedules {
          items {
            id
            route_id
            route {
              id
              name
              route_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              route_type_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              schedules {
                nextToken
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            operator_ids
            cron_expression
            deleted
            deletedAt
            records {
              items {
                id
                schedule_id
                report_url
                operator_id
                start_time
                end_time
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            patrols {
              items {
                id
                schedule_id
                completed
                operator_ids
                datetime
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        route_checkpoints {
          items {
            id
            route_id
            checkpoint_id
            order
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        type
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listRoutesByCreatedAt = /* GraphQL */ `
  query ListRoutesByCreatedAt(
    $type: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelRouteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRoutesByCreatedAt(
      type: $type
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        route_type {
          id
          name
          routes {
            items {
              id
              name
              route_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              route_type_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              schedules {
                nextToken
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        route_type_id
        site {
          id
          csid
          name
          description
          latitude
          longitude
          geohash
          address
          customer_name
          cameras {
            items {
              id
              camera_asset_id
              name
              latitude
              longitude
              geohash
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              checkpoints {
                nextToken
                __typename
              }
              http_stream
              video_gateway
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          routes {
            items {
              id
              name
              route_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              route_type_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              schedules {
                nextToken
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          checkpoints {
            items {
              id
              name
              description
              checklist
              site_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              camera_id
              camera {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        site_id
        schedules {
          items {
            id
            route_id
            route {
              id
              name
              route_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              route_type_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              schedules {
                nextToken
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            operator_ids
            cron_expression
            deleted
            deletedAt
            records {
              items {
                id
                schedule_id
                report_url
                operator_id
                start_time
                end_time
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            patrols {
              items {
                id
                schedule_id
                completed
                operator_ids
                datetime
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        route_checkpoints {
          items {
            id
            route_id
            checkpoint_id
            order
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        type
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listRoutesByUpdatedAt = /* GraphQL */ `
  query ListRoutesByUpdatedAt(
    $type: String!
    $updatedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelRouteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRoutesByUpdatedAt(
      type: $type
      updatedAt: $updatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        route_type {
          name
        }
        site {
          name
        }
        route_checkpoints {
          items {
            id
            route_id
            checkpoint_id
            order
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        schedules {
          items {
            id
          }
        }
        type
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getRouteType = /* GraphQL */ `
  query GetRouteType($id: ID!) {
    getRouteType(id: $id) {
      id
      name
      routes {
        items {
          id
          name
          route_type {
            id
            name
            routes {
              items {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          route_type_id
          site {
            id
            csid
            name
            description
            latitude
            longitude
            geohash
            address
            customer_name
            cameras {
              items {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            routes {
              items {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          site_id
          schedules {
            items {
              id
              route_id
              route {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              operator_ids
              cron_expression
              deleted
              deletedAt
              records {
                nextToken
                __typename
              }
              patrols {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          route_checkpoints {
            items {
              id
              route_id
              checkpoint_id
              order
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          type
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listRouteTypes = /* GraphQL */ `
  query ListRouteTypes(
    $id: ID
    $filter: ModelRouteTypeFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listRouteTypes(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        name
        routes {
          items {
            id
            name
            route_type {
              id
              name
              routes {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            route_type_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            site_id
            schedules {
              items {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getRouteCheckPoints = /* GraphQL */ `
  query GetRouteCheckPoints($id: ID!) {
    getRouteCheckPoints(id: $id) {
      id
      route_id
      checkpoint_id
      order
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listRouteCheckPoints = /* GraphQL */ `
  query ListRouteCheckPoints(
    $id: ID
    $filter: ModelRouteCheckPointsFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listRouteCheckPoints(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        route_id
        checkpoint_id
        checkpoint {
          name
        }
        order
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listCheckpointsByRoute = /* GraphQL */ `
  query ListCheckpointsByRoute(
    $route_id: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelRouteCheckPointsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCheckpointsByRoute(
      route_id: $route_id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        route_id
        checkpoint_id
        checkpoint {
          name
        }
        order
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const routeCheckPointsByCheckpoint_id = /* GraphQL */ `
  query RouteCheckPointsByCheckpoint_id(
    $checkpoint_id: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelRouteCheckPointsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    routeCheckPointsByCheckpoint_id(
      checkpoint_id: $checkpoint_id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        route_id
        checkpoint_id
        order
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCheckpoint = /* GraphQL */ `
  query GetCheckpoint($id: ID!) {
    getCheckpoint(id: $id) {
      id
      name
      description
      checklist
      site_id
      site {
        id
        csid
        name
        description
        latitude
        longitude
        geohash
        address
        customer_name
        cameras {
          items {
            id
            camera_asset_id
            name
            latitude
            longitude
            geohash
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            site_id
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            http_stream
            video_gateway
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        routes {
          items {
            id
            name
            route_type {
              id
              name
              routes {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            route_type_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            site_id
            schedules {
              items {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        checkpoints {
          items {
            id
            name
            description
            checklist
            site_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            camera_id
            camera {
              id
              camera_asset_id
              name
              latitude
              longitude
              geohash
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              checkpoints {
                nextToken
                __typename
              }
              http_stream
              video_gateway
              createdAt
              updatedAt
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      camera_id
      camera {
        id
        camera_asset_id
        name
        latitude
        longitude
        geohash
        site {
          id
          csid
          name
          description
          latitude
          longitude
          geohash
          address
          customer_name
          cameras {
            items {
              id
              camera_asset_id
              name
              latitude
              longitude
              geohash
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              checkpoints {
                nextToken
                __typename
              }
              http_stream
              video_gateway
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          routes {
            items {
              id
              name
              route_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              route_type_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              schedules {
                nextToken
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          checkpoints {
            items {
              id
              name
              description
              checklist
              site_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              camera_id
              camera {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        site_id
        checkpoints {
          items {
            id
            name
            description
            checklist
            site_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            camera_id
            camera {
              id
              camera_asset_id
              name
              latitude
              longitude
              geohash
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              checkpoints {
                nextToken
                __typename
              }
              http_stream
              video_gateway
              createdAt
              updatedAt
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        http_stream
        video_gateway
        createdAt
        updatedAt
        __typename
      }
      route_checkpoints {
        items {
          id
          route_id
          checkpoint_id
          order
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      checkpoint_records {
        items {
          id
          order
          record_id
          record {
            id
            schedule_id
            schedule {
              id
              route_id
              route {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              operator_ids
              cron_expression
              deleted
              deletedAt
              records {
                nextToken
                __typename
              }
              patrols {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            report_url
            operator_id
            start_time
            end_time
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          checkpoint_id
          checkpoint {
            id
            name
            description
            checklist
            site_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            camera_id
            camera {
              id
              camera_asset_id
              name
              latitude
              longitude
              geohash
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              checkpoints {
                nextToken
                __typename
              }
              http_stream
              video_gateway
              createdAt
              updatedAt
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          incident_type_id
          incident_type {
            id
            name
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          checklist_results
          completed_at
          image_url
          notes
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      type
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCheckpoints = /* GraphQL */ `
  query ListCheckpoints(
    $id: ID
    $filter: ModelCheckpointFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listCheckpoints(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        name
        description
        checklist
      }
      nextToken
      __typename
    }
  }
`;
export const listCheckpointsBySite = /* GraphQL */ `
  query ListCheckpointsBySite(
    $site_id: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCheckpointFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCheckpointsBySite(
      site_id: $site_id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        checklist
        site_id
        site {
          id
          csid
          name
          description
          latitude
          longitude
          geohash
          address
          customer_name
          cameras {
            items {
              id
              camera_asset_id
              name
              latitude
              longitude
              geohash
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              checkpoints {
                nextToken
                __typename
              }
              http_stream
              video_gateway
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          routes {
            items {
              id
              name
              route_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              route_type_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              schedules {
                nextToken
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          checkpoints {
            items {
              id
              name
              description
              checklist
              site_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              camera_id
              camera {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        camera_id
        camera {
          id
          camera_asset_id
          name
          latitude
          longitude
          geohash
          site {
            id
            csid
            name
            description
            latitude
            longitude
            geohash
            address
            customer_name
            cameras {
              items {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            routes {
              items {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          site_id
          checkpoints {
            items {
              id
              name
              description
              checklist
              site_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              camera_id
              camera {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          http_stream
          video_gateway
          createdAt
          updatedAt
          __typename
        }
        route_checkpoints {
          items {
            id
            route_id
            checkpoint_id
            order
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        checkpoint_records {
          items {
            id
            order
            record_id
            record {
              id
              schedule_id
              schedule {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              report_url
              operator_id
              start_time
              end_time
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            checkpoint_id
            checkpoint {
              id
              name
              description
              checklist
              site_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              camera_id
              camera {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            incident_type_id
            incident_type {
              id
              name
              checkpoint_records {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            checklist_results
            completed_at
            image_url
            notes
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        type
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listCheckpointsByCamera = /* GraphQL */ `
  query ListCheckpointsByCamera(
    $camera_id: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCheckpointFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCheckpointsByCamera(
      camera_id: $camera_id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        checklist
        site_id
        site {
          id
          csid
          name
          description
          latitude
          longitude
          geohash
          address
          customer_name
          cameras {
            items {
              id
              camera_asset_id
              name
              latitude
              longitude
              geohash
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              checkpoints {
                nextToken
                __typename
              }
              http_stream
              video_gateway
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          routes {
            items {
              id
              name
              route_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              route_type_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              schedules {
                nextToken
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          checkpoints {
            items {
              id
              name
              description
              checklist
              site_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              camera_id
              camera {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        camera_id
        camera {
          id
          camera_asset_id
          name
          latitude
          longitude
          geohash
          site {
            id
            csid
            name
            description
            latitude
            longitude
            geohash
            address
            customer_name
            cameras {
              items {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            routes {
              items {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          site_id
          checkpoints {
            items {
              id
              name
              description
              checklist
              site_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              camera_id
              camera {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          http_stream
          video_gateway
          createdAt
          updatedAt
          __typename
        }
        route_checkpoints {
          items {
            id
            route_id
            checkpoint_id
            order
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        checkpoint_records {
          items {
            id
            order
            record_id
            record {
              id
              schedule_id
              schedule {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              report_url
              operator_id
              start_time
              end_time
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            checkpoint_id
            checkpoint {
              id
              name
              description
              checklist
              site_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              camera_id
              camera {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            incident_type_id
            incident_type {
              id
              name
              checkpoint_records {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            checklist_results
            completed_at
            image_url
            notes
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        type
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listCheckpointsByCreatedAt = /* GraphQL */ `
  query ListCheckpointsByCreatedAt(
    $type: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCheckpointFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCheckpointsByCreatedAt(
      type: $type
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        checklist
        site_id
        site {
          id
          csid
          name
          description
          latitude
          longitude
          geohash
          address
          customer_name
          cameras {
            items {
              id
              camera_asset_id
              name
              latitude
              longitude
              geohash
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              checkpoints {
                nextToken
                __typename
              }
              http_stream
              video_gateway
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          routes {
            items {
              id
              name
              route_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              route_type_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              schedules {
                nextToken
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          checkpoints {
            items {
              id
              name
              description
              checklist
              site_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              camera_id
              camera {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        camera_id
        camera {
          id
          camera_asset_id
          name
          latitude
          longitude
          geohash
          site {
            id
            csid
            name
            description
            latitude
            longitude
            geohash
            address
            customer_name
            cameras {
              items {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            routes {
              items {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          site_id
          checkpoints {
            items {
              id
              name
              description
              checklist
              site_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              camera_id
              camera {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          http_stream
          video_gateway
          createdAt
          updatedAt
          __typename
        }
        route_checkpoints {
          items {
            id
            route_id
            checkpoint_id
            order
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        checkpoint_records {
          items {
            id
            order
            record_id
            record {
              id
              schedule_id
              schedule {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              report_url
              operator_id
              start_time
              end_time
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            checkpoint_id
            checkpoint {
              id
              name
              description
              checklist
              site_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              camera_id
              camera {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            incident_type_id
            incident_type {
              id
              name
              checkpoint_records {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            checklist_results
            completed_at
            image_url
            notes
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        type
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listCheckpointsByUpdatedAt = /* GraphQL */ `
  query ListCheckpointsByUpdatedAt(
    $type: String!
    $updatedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCheckpointFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCheckpointsByUpdatedAt(
      type: $type
      updatedAt: $updatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        checklist
        site {
          name
        }
        camera {
          name
        }
        route_checkpoints {
          items {
            id
          }
        }
        type
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSchedule = /* GraphQL */ `
  query GetSchedule($id: ID!) {
    getSchedule(id: $id) {
      id
      route_id
      route {
        id
        name
      }
      records {
        items {
          id
        }
      }
      operator_ids
      cron_expression
      deleted
      deletedAt
      type
      createdAt
      updatedAt
    }
  }
`;
export const listSchedules = /* GraphQL */ `
  query ListSchedules(
    $id: ID
    $filter: ModelScheduleFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSchedules(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        route_id
        route {
          id
          name
          route_type {
            id
            name
            routes {
              items {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          route_type_id
          site {
            id
            csid
            name
            description
            latitude
            longitude
            geohash
            address
            customer_name
            cameras {
              items {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            routes {
              items {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          site_id
          schedules {
            items {
              id
              route_id
              route {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              operator_ids
              cron_expression
              deleted
              deletedAt
              records {
                nextToken
                __typename
              }
              patrols {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          route_checkpoints {
            items {
              id
              route_id
              checkpoint_id
              order
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          type
          createdAt
          updatedAt
          __typename
        }
        operator_ids
        cron_expression
        deleted
        deletedAt
        records {
          items {
            id
            schedule_id
            schedule {
              id
              route_id
              route {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              operator_ids
              cron_expression
              deleted
              deletedAt
              records {
                nextToken
                __typename
              }
              patrols {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            report_url
            operator_id
            start_time
            end_time
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        patrols {
          items {
            id
            schedule_id
            schedule {
              id
              route_id
              route {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              operator_ids
              cron_expression
              deleted
              deletedAt
              records {
                nextToken
                __typename
              }
              patrols {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            completed
            operator_ids
            datetime
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        type
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listSchedulesByRoute = /* GraphQL */ `
  query ListSchedulesByRoute(
    $route_id: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelScheduleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSchedulesByRoute(
      route_id: $route_id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        route_id
        route {
          id
          name
          route_type {
            id
            name
            routes {
              items {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          route_type_id
          site {
            id
            csid
            name
            description
            latitude
            longitude
            geohash
            address
            customer_name
            cameras {
              items {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            routes {
              items {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          site_id
          schedules {
            items {
              id
              route_id
              route {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              operator_ids
              cron_expression
              deleted
              deletedAt
              records {
                nextToken
                __typename
              }
              patrols {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          route_checkpoints {
            items {
              id
              route_id
              checkpoint_id
              order
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          type
          createdAt
          updatedAt
          __typename
        }
        operator_ids
        cron_expression
        deleted
        deletedAt
        records {
          items {
            id
            schedule_id
            schedule {
              id
              route_id
              route {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              operator_ids
              cron_expression
              deleted
              deletedAt
              records {
                nextToken
                __typename
              }
              patrols {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            report_url
            operator_id
            start_time
            end_time
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        patrols {
          items {
            id
            schedule_id
            schedule {
              id
              route_id
              route {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              operator_ids
              cron_expression
              deleted
              deletedAt
              records {
                nextToken
                __typename
              }
              patrols {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            completed
            operator_ids
            datetime
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        type
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listSchedulesByCreatedAt = /* GraphQL */ `
  query ListSchedulesByCreatedAt(
    $type: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelScheduleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSchedulesByCreatedAt(
      type: $type
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        route_id
        route {
          id
          name
          route_type {
            id
            name
            routes {
              items {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          route_type_id
          site {
            id
            csid
            name
            description
            latitude
            longitude
            geohash
            address
            customer_name
            cameras {
              items {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            routes {
              items {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          site_id
          schedules {
            items {
              id
              route_id
              route {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              operator_ids
              cron_expression
              deleted
              deletedAt
              records {
                nextToken
                __typename
              }
              patrols {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          route_checkpoints {
            items {
              id
              route_id
              checkpoint_id
              order
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          type
          createdAt
          updatedAt
          __typename
        }
        operator_ids
        cron_expression
        deleted
        deletedAt
        records {
          items {
            id
            schedule_id
            schedule {
              id
              route_id
              route {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              operator_ids
              cron_expression
              deleted
              deletedAt
              records {
                nextToken
                __typename
              }
              patrols {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            report_url
            operator_id
            start_time
            end_time
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        patrols {
          items {
            id
            schedule_id
            schedule {
              id
              route_id
              route {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              operator_ids
              cron_expression
              deleted
              deletedAt
              records {
                nextToken
                __typename
              }
              patrols {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            completed
            operator_ids
            datetime
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        type
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listSchedulesByUpdatedAt = /* GraphQL */ `
  query ListSchedulesByUpdatedAt(
    $type: String!
    $updatedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelScheduleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSchedulesByUpdatedAt(
      type: $type
      updatedAt: $updatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        route_id
        route {
          id
          name
        }
        operator_ids
        cron_expression
        records {
          items {
            id
          }
        } 
        deleted
        deletedAt
        updatedAt
        type
        createdAt
      }
      nextToken
    }
  }
`;
export const getPatrol = /* GraphQL */ `
  query GetPatrol($id: ID!) {
    getPatrol(id: $id) {
      id
      schedule_id
      schedule {
        id
        route_id
        route {
          id
          name
          route_type {
            id
            name
            routes {
              items {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          route_type_id
          site {
            id
            csid
            name
            description
            latitude
            longitude
            geohash
            address
            customer_name
            cameras {
              items {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            routes {
              items {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          site_id
          schedules {
            items {
              id
              route_id
              route {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              operator_ids
              cron_expression
              deleted
              deletedAt
              records {
                nextToken
                __typename
              }
              patrols {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          route_checkpoints {
            items {
              id
              route_id
              checkpoint_id
              order
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          type
          createdAt
          updatedAt
          __typename
        }
        operator_ids
        cron_expression
        deleted
        deletedAt
        records {
          items {
            id
            schedule_id
            schedule {
              id
              route_id
              route {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              operator_ids
              cron_expression
              deleted
              deletedAt
              records {
                nextToken
                __typename
              }
              patrols {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            report_url
            operator_id
            start_time
            end_time
            checkpoint_records {
              items {
                id
                order
                record_id
                checkpoint_id
                incident_type_id
                checklist_results
                completed_at
                image_url
                notes
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        patrols {
          items {
            id
            schedule_id
            schedule {
              id
              route_id
              route {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              operator_ids
              cron_expression
              deleted
              deletedAt
              records {
                nextToken
                __typename
              }
              patrols {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            completed
            operator_ids
            datetime
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        type
        createdAt
        updatedAt
        __typename
      }
      completed
      operator_ids
      datetime
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listPatrols = /* GraphQL */ `
  query ListPatrols(
    $id: ID
    $filter: ModelPatrolFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listPatrols(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        schedule_id
        schedule {
          id
          route_id
          route {
            id
            name
            site_id
            schedules {
              items {
                deleted
              }
              nextToken
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          operator_ids
          cron_expression
          deleted
          deletedAt
          type
          createdAt
          updatedAt
          __typename
        }
        completed
        operator_ids
        datetime
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listPatrolsBySchedule = /* GraphQL */ `
  query ListPatrolsBySchedule(
    $schedule_id: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelPatrolFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPatrolsBySchedule(
      schedule_id: $schedule_id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        schedule_id
        schedule {
          id
          route_id
          route {
            id
            name
            route_type {
              id
              name
              routes {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            route_type_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            site_id
            schedules {
              items {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          operator_ids
          cron_expression
          deleted
          deletedAt
          records {
            items {
              id
              schedule_id
              schedule {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              report_url
              operator_id
              start_time
              end_time
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          patrols {
            items {
              id
              schedule_id
              schedule {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              completed
              operator_ids
              datetime
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          type
          createdAt
          updatedAt
          __typename
        }
        completed
        operator_ids
        datetime
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listPatrolsByDateTime = /* GraphQL */ `
  query ListPatrolsByDateTime(
    $datetime: AWSDateTime!
    $sortDirection: ModelSortDirection
    $filter: ModelPatrolFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPatrolsByDateTime(
      datetime: $datetime
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        schedule_id
        schedule {
          id
          route_id
          route {
            id
            name
            route_type {
              id
              name
              routes {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            route_type_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            site_id
            schedules {
              items {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          operator_ids
          cron_expression
          deleted
          deletedAt
          records {
            items {
              id
              schedule_id
              schedule {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              report_url
              operator_id
              start_time
              end_time
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          patrols {
            items {
              id
              schedule_id
              schedule {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              completed
              operator_ids
              datetime
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          type
          createdAt
          updatedAt
          __typename
        }
        completed
        operator_ids
        datetime
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getRecord = /* GraphQL */ `
  query GetRecord($id: ID!) {
    getRecord(id: $id) {
      id
      schedule_id
      schedule {
        route {
          name
          site {
            name
          }
        }
        operator_ids
        deleted
        deletedAt
      }
      report_url
      operator_id
      checkpoint_records {
        items {
          id
          order
          checkpoint_id
          checkpoint {
            name
          }
          checklist_results
          completed_at
          image_url
          notes
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      type
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listRecords = /* GraphQL */ `
  query ListRecords(
    $id: ID
    $filter: ModelRecordFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listRecords(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        schedule_id
        schedule {
          id
          route_id
          route {
            id
            name
            route_type {
              id
              name
              routes {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            route_type_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            site_id
            schedules {
              items {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          operator_ids
          cron_expression
          deleted
          deletedAt
          records {
            items {
              id
              schedule_id
              schedule {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              report_url
              operator_id
              start_time
              end_time
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          patrols {
            items {
              id
              schedule_id
              schedule {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              completed
              operator_ids
              datetime
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          type
          createdAt
          updatedAt
          __typename
        }
        report_url
        operator_id
        start_time
        end_time
        checkpoint_records {
          items {
            id
            order
            record_id
            record {
              id
              schedule_id
              schedule {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              report_url
              operator_id
              start_time
              end_time
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            checkpoint_id
            checkpoint {
              id
              name
              description
              checklist
              site_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              camera_id
              camera {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            incident_type_id
            incident_type {
              id
              name
              checkpoint_records {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            checklist_results
            completed_at
            image_url
            notes
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        type
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listRecordsBySchedule = /* GraphQL */ `
  query ListRecordsBySchedule(
    $schedule_id: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelRecordFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRecordsBySchedule(
      schedule_id: $schedule_id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        schedule_id
        schedule {
          id
          route_id
          route {
            id
            name
            route_type {
              id
              name
              routes {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            route_type_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            site_id
            schedules {
              items {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          operator_ids
          cron_expression
          deleted
          deletedAt
          records {
            items {
              id
              schedule_id
              schedule {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              report_url
              operator_id
              start_time
              end_time
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          patrols {
            items {
              id
              schedule_id
              schedule {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              completed
              operator_ids
              datetime
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          type
          createdAt
          updatedAt
          __typename
        }
        report_url
        operator_id
        start_time
        end_time
        checkpoint_records {
          items {
            id
            order
            record_id
            record {
              id
              schedule_id
              schedule {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              report_url
              operator_id
              start_time
              end_time
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            checkpoint_id
            checkpoint {
              id
              name
              description
              checklist
              site_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              camera_id
              camera {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            incident_type_id
            incident_type {
              id
              name
              checkpoint_records {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            checklist_results
            completed_at
            image_url
            notes
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        type
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listRecordsByCreatedAt = /* GraphQL */ `
  query ListRecordsByCreatedAt(
    $type: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelRecordFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRecordsByCreatedAt(
      type: $type
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        schedule_id
        schedule {
          id
          route_id
          route {
            id
            name
            route_type {
              id
              name
              routes {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            route_type_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            site_id
            schedules {
              items {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          operator_ids
          cron_expression
          deleted
          deletedAt
          records {
            items {
              id
              schedule_id
              schedule {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              report_url
              operator_id
              start_time
              end_time
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          patrols {
            items {
              id
              schedule_id
              schedule {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              completed
              operator_ids
              datetime
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          type
          createdAt
          updatedAt
          __typename
        }
        report_url
        operator_id
        start_time
        end_time
        checkpoint_records {
          items {
            id
            order
            record_id
            record {
              id
              schedule_id
              schedule {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              report_url
              operator_id
              start_time
              end_time
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            checkpoint_id
            checkpoint {
              id
              name
              description
              checklist
              site_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              camera_id
              camera {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            incident_type_id
            incident_type {
              id
              name
              checkpoint_records {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            checklist_results
            completed_at
            image_url
            notes
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        type
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listRecordsByUpdatedAt = /* GraphQL */ `
  query ListRecordsByUpdatedAt(
    $type: String!
    $updatedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelRecordFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRecordsByUpdatedAt(
      type: $type
      updatedAt: $updatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        schedule {
          route {
            name
            site {
              name
            }
          }
          operator_ids
          deleted
          deletedAt
        }
        report_url
        operator_id
        checkpoint_records {
          items {
            id
          }
          nextToken
        }
        type
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCheckpointRecord = /* GraphQL */ `
  query GetCheckpointRecord($id: ID!) {
    getCheckpointRecord(id: $id) {
      id
      order
      record_id
      record {
        id
        schedule_id
        schedule {
          id
          route_id
          route {
            id
            name
            route_type {
              id
              name
              routes {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            route_type_id
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            site_id
            schedules {
              items {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            route_checkpoints {
              items {
                id
                route_id
                checkpoint_id
                order
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          operator_ids
          cron_expression
          deleted
          deletedAt
          records {
            items {
              id
              schedule_id
              schedule {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              report_url
              operator_id
              start_time
              end_time
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          patrols {
            items {
              id
              schedule_id
              schedule {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              completed
              operator_ids
              datetime
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          type
          createdAt
          updatedAt
          __typename
        }
        report_url
        operator_id
        start_time
        end_time
        checkpoint_records {
          items {
            id
            order
            record_id
            record {
              id
              schedule_id
              schedule {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              report_url
              operator_id
              start_time
              end_time
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            checkpoint_id
            checkpoint {
              id
              name
              description
              checklist
              site_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              camera_id
              camera {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            incident_type_id
            incident_type {
              id
              name
              checkpoint_records {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            checklist_results
            completed_at
            image_url
            notes
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        type
        createdAt
        updatedAt
        __typename
      }
      checkpoint_id
      checkpoint {
        id
        name
        description
        checklist
        site_id
        site {
          id
          csid
          name
          description
          latitude
          longitude
          geohash
          address
          customer_name
          cameras {
            items {
              id
              camera_asset_id
              name
              latitude
              longitude
              geohash
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              checkpoints {
                nextToken
                __typename
              }
              http_stream
              video_gateway
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          routes {
            items {
              id
              name
              route_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              route_type_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              schedules {
                nextToken
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          checkpoints {
            items {
              id
              name
              description
              checklist
              site_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              camera_id
              camera {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        camera_id
        camera {
          id
          camera_asset_id
          name
          latitude
          longitude
          geohash
          site {
            id
            csid
            name
            description
            latitude
            longitude
            geohash
            address
            customer_name
            cameras {
              items {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            routes {
              items {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          site_id
          checkpoints {
            items {
              id
              name
              description
              checklist
              site_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              camera_id
              camera {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          http_stream
          video_gateway
          createdAt
          updatedAt
          __typename
        }
        route_checkpoints {
          items {
            id
            route_id
            checkpoint_id
            order
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        checkpoint_records {
          items {
            id
            order
            record_id
            record {
              id
              schedule_id
              schedule {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              report_url
              operator_id
              start_time
              end_time
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            checkpoint_id
            checkpoint {
              id
              name
              description
              checklist
              site_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              camera_id
              camera {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            incident_type_id
            incident_type {
              id
              name
              checkpoint_records {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            checklist_results
            completed_at
            image_url
            notes
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        type
        createdAt
        updatedAt
        __typename
      }
      incident_type_id
      incident_type {
        id
        name
        checkpoint_records {
          items {
            id
            order
            record_id
            record {
              id
              schedule_id
              schedule {
                id
                route_id
                operator_ids
                cron_expression
                deleted
                deletedAt
                type
                createdAt
                updatedAt
                __typename
              }
              report_url
              operator_id
              start_time
              end_time
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            checkpoint_id
            checkpoint {
              id
              name
              description
              checklist
              site_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              camera_id
              camera {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              checkpoint_records {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            incident_type_id
            incident_type {
              id
              name
              checkpoint_records {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            checklist_results
            completed_at
            image_url
            notes
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      checklist_results
      completed_at
      image_url
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCheckpointRecords = /* GraphQL */ `
  query ListCheckpointRecords(
    $id: ID
    $filter: ModelCheckpointRecordFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listCheckpointRecords(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        order
        record_id
        record {
          id
          schedule_id
          schedule {
            id
            route_id
            route {
              id
              name
              route_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              route_type_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              schedules {
                nextToken
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            operator_ids
            cron_expression
            deleted
            deletedAt
            records {
              items {
                id
                schedule_id
                report_url
                operator_id
                start_time
                end_time
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            patrols {
              items {
                id
                schedule_id
                completed
                operator_ids
                datetime
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          report_url
          operator_id
          start_time
          end_time
          checkpoint_records {
            items {
              id
              order
              record_id
              record {
                id
                schedule_id
                report_url
                operator_id
                start_time
                end_time
                type
                createdAt
                updatedAt
                __typename
              }
              checkpoint_id
              checkpoint {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              incident_type_id
              incident_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              checklist_results
              completed_at
              image_url
              notes
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          type
          createdAt
          updatedAt
          __typename
        }
        checkpoint_id
        checkpoint {
          id
          name
          description
          checklist
          site_id
          site {
            id
            csid
            name
            description
            latitude
            longitude
            geohash
            address
            customer_name
            cameras {
              items {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            routes {
              items {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          camera_id
          camera {
            id
            camera_asset_id
            name
            latitude
            longitude
            geohash
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            site_id
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            http_stream
            video_gateway
            createdAt
            updatedAt
            __typename
          }
          route_checkpoints {
            items {
              id
              route_id
              checkpoint_id
              order
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          checkpoint_records {
            items {
              id
              order
              record_id
              record {
                id
                schedule_id
                report_url
                operator_id
                start_time
                end_time
                type
                createdAt
                updatedAt
                __typename
              }
              checkpoint_id
              checkpoint {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              incident_type_id
              incident_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              checklist_results
              completed_at
              image_url
              notes
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          type
          createdAt
          updatedAt
          __typename
        }
        incident_type_id
        incident_type {
          id
          name
          checkpoint_records {
            items {
              id
              order
              record_id
              record {
                id
                schedule_id
                report_url
                operator_id
                start_time
                end_time
                type
                createdAt
                updatedAt
                __typename
              }
              checkpoint_id
              checkpoint {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              incident_type_id
              incident_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              checklist_results
              completed_at
              image_url
              notes
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        checklist_results
        completed_at
        image_url
        notes
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listCheckpointRecordsByRecord = /* GraphQL */ `
  query ListCheckpointRecordsByRecord(
    $record_id: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCheckpointRecordFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCheckpointRecordsByRecord(
      record_id: $record_id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        order
        record_id
        record {
          id
          schedule_id
          schedule {
            id
            route_id
            route {
              id
              name
              route_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              route_type_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              schedules {
                nextToken
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            operator_ids
            cron_expression
            deleted
            deletedAt
            records {
              items {
                id
                schedule_id
                report_url
                operator_id
                start_time
                end_time
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            patrols {
              items {
                id
                schedule_id
                completed
                operator_ids
                datetime
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          report_url
          operator_id
          start_time
          end_time
          checkpoint_records {
            items {
              id
              order
              record_id
              record {
                id
                schedule_id
                report_url
                operator_id
                start_time
                end_time
                type
                createdAt
                updatedAt
                __typename
              }
              checkpoint_id
              checkpoint {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              incident_type_id
              incident_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              checklist_results
              completed_at
              image_url
              notes
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          type
          createdAt
          updatedAt
          __typename
        }
        checkpoint_id
        checkpoint {
          id
          name
          description
          checklist
          site_id
          site {
            id
            csid
            name
            description
            latitude
            longitude
            geohash
            address
            customer_name
            cameras {
              items {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            routes {
              items {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          camera_id
          camera {
            id
            camera_asset_id
            name
            latitude
            longitude
            geohash
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            site_id
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            http_stream
            video_gateway
            createdAt
            updatedAt
            __typename
          }
          route_checkpoints {
            items {
              id
              route_id
              checkpoint_id
              order
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          checkpoint_records {
            items {
              id
              order
              record_id
              record {
                id
                schedule_id
                report_url
                operator_id
                start_time
                end_time
                type
                createdAt
                updatedAt
                __typename
              }
              checkpoint_id
              checkpoint {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              incident_type_id
              incident_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              checklist_results
              completed_at
              image_url
              notes
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          type
          createdAt
          updatedAt
          __typename
        }
        incident_type_id
        incident_type {
          id
          name
          checkpoint_records {
            items {
              id
              order
              record_id
              record {
                id
                schedule_id
                report_url
                operator_id
                start_time
                end_time
                type
                createdAt
                updatedAt
                __typename
              }
              checkpoint_id
              checkpoint {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              incident_type_id
              incident_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              checklist_results
              completed_at
              image_url
              notes
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        checklist_results
        completed_at
        image_url
        notes
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listCheckpointRecordsByCheckpoint = /* GraphQL */ `
  query ListCheckpointRecordsByCheckpoint(
    $checkpoint_id: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCheckpointRecordFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCheckpointRecordsByCheckpoint(
      checkpoint_id: $checkpoint_id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        order
        record_id
        record {
          id
          schedule_id
          schedule {
            id
            route_id
            route {
              id
              name
              route_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              route_type_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              schedules {
                nextToken
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            operator_ids
            cron_expression
            deleted
            deletedAt
            records {
              items {
                id
                schedule_id
                report_url
                operator_id
                start_time
                end_time
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            patrols {
              items {
                id
                schedule_id
                completed
                operator_ids
                datetime
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          report_url
          operator_id
          start_time
          end_time
          checkpoint_records {
            items {
              id
              order
              record_id
              record {
                id
                schedule_id
                report_url
                operator_id
                start_time
                end_time
                type
                createdAt
                updatedAt
                __typename
              }
              checkpoint_id
              checkpoint {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              incident_type_id
              incident_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              checklist_results
              completed_at
              image_url
              notes
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          type
          createdAt
          updatedAt
          __typename
        }
        checkpoint_id
        checkpoint {
          id
          name
          description
          checklist
          site_id
          site {
            id
            csid
            name
            description
            latitude
            longitude
            geohash
            address
            customer_name
            cameras {
              items {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            routes {
              items {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          camera_id
          camera {
            id
            camera_asset_id
            name
            latitude
            longitude
            geohash
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            site_id
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            http_stream
            video_gateway
            createdAt
            updatedAt
            __typename
          }
          route_checkpoints {
            items {
              id
              route_id
              checkpoint_id
              order
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          checkpoint_records {
            items {
              id
              order
              record_id
              record {
                id
                schedule_id
                report_url
                operator_id
                start_time
                end_time
                type
                createdAt
                updatedAt
                __typename
              }
              checkpoint_id
              checkpoint {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              incident_type_id
              incident_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              checklist_results
              completed_at
              image_url
              notes
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          type
          createdAt
          updatedAt
          __typename
        }
        incident_type_id
        incident_type {
          id
          name
          checkpoint_records {
            items {
              id
              order
              record_id
              record {
                id
                schedule_id
                report_url
                operator_id
                start_time
                end_time
                type
                createdAt
                updatedAt
                __typename
              }
              checkpoint_id
              checkpoint {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              incident_type_id
              incident_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              checklist_results
              completed_at
              image_url
              notes
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        checklist_results
        completed_at
        image_url
        notes
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listCheckpointRecordsByIncidentTypes = /* GraphQL */ `
  query ListCheckpointRecordsByIncidentTypes(
    $incident_type_id: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCheckpointRecordFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCheckpointRecordsByIncidentTypes(
      incident_type_id: $incident_type_id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        order
        record_id
        record {
          id
          schedule_id
          schedule {
            id
            route_id
            route {
              id
              name
              route_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              route_type_id
              site {
                id
                csid
                name
                description
                latitude
                longitude
                geohash
                address
                customer_name
                createdAt
                updatedAt
                __typename
              }
              site_id
              schedules {
                nextToken
                __typename
              }
              route_checkpoints {
                nextToken
                __typename
              }
              type
              createdAt
              updatedAt
              __typename
            }
            operator_ids
            cron_expression
            deleted
            deletedAt
            records {
              items {
                id
                schedule_id
                report_url
                operator_id
                start_time
                end_time
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            patrols {
              items {
                id
                schedule_id
                completed
                operator_ids
                datetime
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            type
            createdAt
            updatedAt
            __typename
          }
          report_url
          operator_id
          start_time
          end_time
          checkpoint_records {
            items {
              id
              order
              record_id
              record {
                id
                schedule_id
                report_url
                operator_id
                start_time
                end_time
                type
                createdAt
                updatedAt
                __typename
              }
              checkpoint_id
              checkpoint {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              incident_type_id
              incident_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              checklist_results
              completed_at
              image_url
              notes
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          type
          createdAt
          updatedAt
          __typename
        }
        checkpoint_id
        checkpoint {
          id
          name
          description
          checklist
          site_id
          site {
            id
            csid
            name
            description
            latitude
            longitude
            geohash
            address
            customer_name
            cameras {
              items {
                id
                camera_asset_id
                name
                latitude
                longitude
                geohash
                site_id
                http_stream
                video_gateway
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            routes {
              items {
                id
                name
                route_type_id
                site_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            createdAt
            updatedAt
            __typename
          }
          camera_id
          camera {
            id
            camera_asset_id
            name
            latitude
            longitude
            geohash
            site {
              id
              csid
              name
              description
              latitude
              longitude
              geohash
              address
              customer_name
              cameras {
                nextToken
                __typename
              }
              routes {
                nextToken
                __typename
              }
              checkpoints {
                nextToken
                __typename
              }
              createdAt
              updatedAt
              __typename
            }
            site_id
            checkpoints {
              items {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              nextToken
              __typename
            }
            http_stream
            video_gateway
            createdAt
            updatedAt
            __typename
          }
          route_checkpoints {
            items {
              id
              route_id
              checkpoint_id
              order
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          checkpoint_records {
            items {
              id
              order
              record_id
              record {
                id
                schedule_id
                report_url
                operator_id
                start_time
                end_time
                type
                createdAt
                updatedAt
                __typename
              }
              checkpoint_id
              checkpoint {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              incident_type_id
              incident_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              checklist_results
              completed_at
              image_url
              notes
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          type
          createdAt
          updatedAt
          __typename
        }
        incident_type_id
        incident_type {
          id
          name
          checkpoint_records {
            items {
              id
              order
              record_id
              record {
                id
                schedule_id
                report_url
                operator_id
                start_time
                end_time
                type
                createdAt
                updatedAt
                __typename
              }
              checkpoint_id
              checkpoint {
                id
                name
                description
                checklist
                site_id
                camera_id
                type
                createdAt
                updatedAt
                __typename
              }
              incident_type_id
              incident_type {
                id
                name
                createdAt
                updatedAt
                __typename
              }
              checklist_results
              completed_at
              image_url
              notes
              createdAt
              updatedAt
              __typename
            }
            nextToken
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        checklist_results
        completed_at
        image_url
        notes
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
